import React from "react";
import IconLarge from "../GeneralSubcomponents/IconLarge.js";
import foto from "../../img/pixelcut-export-_2_.webp";
import email from "../../img/Icons//Update/Mail.png";
import github from "../../img/Icons//Update/GitHub.png";
import linkedin from "../../img/Icons//Update/LinkedIn.png";
import "../../Styles/infoProfile.css";

const InfoProfile = () => (
  <div className="container">
    <div className="o-cont-profile row">
      <div className="col-sm-6 o-hero-left">
        <div className="o-hero-photo-wrap">
          <div className="o-hero-glow"></div>
          <span className="o-hero-badge o-badge-growth">
            <i className="fas fa-chart-line"></i>
            <span>Growth Focused</span>
          </span>
          <span className="o-hero-badge o-badge-automation">
            <i className="fas fa-bolt"></i>
            <span>Automation Systems</span>
          </span>
          <span className="o-hero-badge o-badge-conversion">
            <i className="fas fa-bullseye"></i>
            <span>Conversion Driven</span>
          </span>
          <img src={foto} className="img-fluid o-photo" alt="Laura Valentina Garcés Ángel" />
          <div className="o-hero-dots" aria-hidden="true"></div>
        </div>
      </div>
      <div className="col-sm-6 o-contInfo">
        <div className="row o-name">
          <p className="o-hero-name">Laura Valentina Garcés Ángel</p>
          <p className="o-hero-role">Frontend Developer → GTM & Automation</p>
          <h1 className="o-nameT">
            I build systems that <span>generate leads</span> and{" "}
            <span>grow businesses.</span>
          </h1>
          <p className="o-hero-subtitle">
            Frontend Developer focused on GTM, automation, and growth systems
          </p>
          <div className="o-hero-divider"></div>
        </div>

        <div className="row o-obj">
          <p>
            I combine frontend development, analytics, and automation to build
            systems that drive real business growth.
          </p>
          <p>
            With 3+ years building production-ready applications, I now focus
            on creating solutions that improve conversions and automate
            workflows.
          </p>
        </div>

        <div className="o-hero-pills">
          <span className="o-hero-pill">Frontend Development</span>
          <span className="o-hero-pill">Automation & Systems</span>
          <span className="o-hero-pill">Growth & Conversion</span>
          <span className="o-hero-pill">Testing & Quality</span>
        </div>

        <div className="o-hero-metrics">
          <div className="o-hero-metric">
            <strong>3+</strong>
            <span>Years Experience</span>
          </div>
          <div className="o-hero-metric">
            <strong>10+</strong>
            <span>Production Projects</span>
          </div>
          <div className="o-hero-metric">
            <strong>Growth</strong>
            <span>& Conversion Focused</span>
          </div>
          <div className="o-hero-metric">
            <strong>∞</strong>
            <span>Always Learning</span>
          </div>
        </div>

        <p className="o-hero-cta">Let’s build your next growth system 🚀</p>
        <div className="col">
          <div className="row o-opt">
            <a href="https://github.com/lvgarces" target="_blank" rel="noreferrer">
              <IconLarge iconL={github} />{" "}
            </a>
            <a
              href="mailto:lauraval.garces@gmail.com"
              target="_blank"
              rel="noreferrer"
              style={{ margin: "auto 0.5rem" }}
            >
              <IconLarge iconL={email} />{" "}
            </a>
            <a
              href="https://www.linkedin.com/in/laura-valentina-garces-angel/"
              target="_blank"
              rel="noreferrer"
            >
              <IconLarge iconL={linkedin} />{" "}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default InfoProfile;
